import React from 'react';
import { ArrowRight } from 'lucide-react';
import { STARTER } from '../config/offer';
import { useLeadForm } from './lead/LeadForm';

type StarterCtaProps = { className?: string; source?: string; label?: string };

// Opens the short "let's begin" form. `source` tags which button on the page was used.
const StarterCta: React.FC<StarterCtaProps> = ({ className = '', source = 'site', label = STARTER.label }) => {
  const { open } = useLeadForm();
  return (
    <button
      type="button"
      onClick={() => open(source)}
      data-testid="starter-cta"
      className={`group inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-lavender-700 text-white font-bold shadow-sm hover:bg-lavender-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lavender-700 transition-colors duration-300 ${className}`}
    >
      {label}
      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
    </button>
  );
};

export default StarterCta;
